import { useSyncExternalStore } from "react";
function subscribeWindowResize(callback) {
    window.addEventListener("resize", callback);
    return () => {
        window.removeEventListener("resize", callback);
    };
}
/**
 * Check max height of labels at every window resize event,
 * but trigger re-render only if calculated max height is changed.
 * @private This hook is internal use only for useSyncFieldsLabels!
 */
export function useGetMaxHeightOnResize(labelElements) {
    return useSyncExternalStore(subscribeWindowResize, () => {
        const labelsHeights = labelElements.map((labelElement) => {
            // Combine heights of all children of label element,
            // because <label> in our forms can have multiple children <div>'s
            return Array.from(labelElement.children).reduce((acc, currElement) => {
                return acc + currElement.clientHeight;
            }, 0);
        });
        return Math.max(...labelsHeights);
    });
}
//# sourceMappingURL=useGetMaxHeightOnResize.js.map